module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1014-76eb568fbef95622475aebfae467ccf4.png";